function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import 'react-dates/initialize';
import { DateRangePicker as DatePicker } from 'react-dates';
import PropTypes from 'prop-types';
import { Icon } from "../..";
import Form from "../Form";
import Tooltip from "../Tooltip";
import "./style.css";
import { getRest } from "../../utils";

/**
 * Date range.
 *
 * @class DateRange
 * @extends {React.Component}
 * @deprecated  This component is deprecated and will be removed in next major release.
 *              Veuillez utiliser SingleDatePicker ou DateRangePicker à la place.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DateRange = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DateRange, _React$Component);
  /**
     * Creates an instance of DateRange.
      * @param {*} args
     * @memberof DateRange
     */
  function DateRange() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    /**
       *
       * @memberof DateRange
       */
    _this.updateStartDate = function (startDate) {
      _this.setState({
        startDate: !_.isNil(startDate) ? moment.utc(startDate, 'YYYY-MM-DD') : null
      });
    };
    /**
       *
       * @memberof DateRange
       */
    _this.updateEndDate = function (endDate) {
      _this.setState({
        endDate: !_.isNil(endDate) ? moment.utc(endDate, 'YYYY-MM-DD') : null
      });
    };
    /**
       * Handle focus change.
       *
       * @memberof DateRange
       */
    _this.handleFocusChange = function (focused) {
      _this.setState({
        focused: focused
      });
      _.invoke(_this.props, 'onFocusChange', focused);
    };
    /**
       * Handle dates change.
       *
       * @memberof DateRange
       */
    _this.handleDatesChange = function (_ref) {
      var startDate = _ref.startDate,
        endDate = _ref.endDate;
      var minDateEnd = startDate;
      var maxDateStart = endDate;
      var error = null;
      var _this$state = _this.state,
        minDateStart = _this$state.minDateStart,
        maxDateEnd = _this$state.maxDateEnd;
      if (_.isNil(startDate) && _.isNil(endDate)) {
        error = "Valeurs entre " + minDateStart.format('DD/MM/YYYY') + " et " + maxDateEnd.format('DD/MM/YYYY');
      } else if (_.isNil(endDate)) {
        error = "Valeurs entre " + minDateEnd.format('DD/MM/YYYY') + " et " + maxDateEnd.format('DD/MM/YYYY');
      } else if (_.isNil(startDate)) {
        error = "Valeurs entre " + minDateStart.format('DD/MM/YYYY') + " et " + maxDateStart.format('DD/MM/YYYY');
      }
      _this.setState({
        startDate: startDate,
        endDate: endDate,
        // eslint-disable-next-line react/no-unused-state
        minDateEnd: minDateEnd,
        // eslint-disable-next-line react/no-unused-state
        maxDateStart: maxDateStart,
        error: error
      });
      if (!_.isNil(startDate) && !_.isNil(endDate)) {
        _.invoke(_this.props, 'onDatesChange', {
          startDate: startDate.format('YYYY-MM-DD'),
          endDate: endDate.format('YYYY-MM-DD')
        });
      }
    };
    /**
       * Handle clear event.
       *
       * @memberOf DateRange
       */
    _this.handleClear = function () {
      _.invoke(_this.props, 'onClear');
    };
    /**
       * Render picker.
       *
       * @memberof DateRange
       */
    _this.renderPicker = function () {
      var _this$props = _this.props,
        calendar = _this$props.calendar,
        clearable = _this$props.clearable,
        minDate = _this$props.minDate,
        maxDate = _this$props.maxDate;
      var _this$state2 = _this.state,
        startDate = _this$state2.startDate,
        endDate = _this$state2.endDate,
        focused = _this$state2.focused;
      var rest = getRest(DateRange, _this.props);
      var calendarProps = !_.isNil(calendar) ? null : {
        focusedInput: focused,
        showDefaultInputIcon: true,
        inputIconPosition: 'after'
      };
      var clearableProps = !_.isNil(clearable) ? null : {
        showClearDates: true,
        customCloseIcon: /*#__PURE__*/_jsx("span", {
          role: "button",
          tabIndex: 0,
          onKeyPress: _this.handleClear,
          onClick: _this.handleClear,
          children: /*#__PURE__*/_jsx(Icon, {
            link: true,
            size: "small",
            name: "x"
          })
        })
      };
      return /*#__PURE__*/_jsx(DatePicker, Object.assign({
        startDate: startDate,
        endDate: endDate,
        endDateId: _.uniqueId(),
        startDateId: _.uniqueId(),
        startDatePlaceholderText: "D\xE9but",
        endDatePlaceholderText: "Fin",
        transitionDuration: 0,
        hideKeyboardShortcutsPanel: true,
        isOutsideRange:
        // eslint-disable-next-line no-nested-ternary
        function isOutsideRange(date) {
          return !_.isNil(minDate) && _.isNil(maxDate) ? date.isSameOrBefore(minDate, 'day')
          // eslint-disable-next-line no-nested-ternary
          : _.isNil(minDate) && !_.isNil(maxDate) ? date.isAfter(maxDate, 'day') : !_.isNil(minDate) && !_.isNil(maxDate) ? date.isSameOrBefore(minDate, 'day') || date.isAfter(maxDate, 'day') : false;
        },
        minDate: moment.utc(minDate, 'YYYY-MM-DD'),
        maxDate: moment.utc(maxDate, 'YYYY-MM-DD'),
        reopenPickerOnClearDates: true,
        navPrev: /*#__PURE__*/_jsx(Icon, {
          name: "angle left",
          size: "large",
          style: {
            left: 22,
            padding: 3,
            position: 'absolute',
            top: 19
          }
        }),
        navNext: /*#__PURE__*/_jsx(Icon, {
          name: "angle right",
          size: "large",
          style: {
            top: 19,
            right: 22,
            padding: 3,
            position: 'absolute'
          }
        })
      }, calendarProps, clearableProps, rest, {
        onDatesChange: _this.handleDatesChange,
        onFocusChange: _this.handleFocusChange
      }));
    };
    var _this$props2 = _this.props,
      _startDate = _this$props2.startDate,
      _endDate = _this$props2.endDate,
      _minDate = _this$props2.minDate,
      _maxDate = _this$props2.maxDate;
    _this.state = {
      startDate: !_.isNil(_startDate) ? moment.utc(_startDate, 'YYYY-MM-DD') : null,
      endDate: !_.isNil(_endDate) ? moment.utc(_endDate, 'YYYY-MM-DD') : null,
      minDateStart: moment.utc(_minDate, 'YYYY-MM-DD'),
      // eslint-disable-next-line react/no-unused-state
      maxDateStart: moment.utc(_endDate, 'YYYY-MM-DD') <= moment.utc(_maxDate, 'YYYY-MM-DD') ? moment.utc(_endDate, 'YYYY-MM-DD') : moment.utc(_maxDate, 'YYYY-MM-DD'),
      // eslint-disable-next-line react/no-unused-state
      minDateEnd: moment.utc(_startDate, 'YYYY-MM-DD') >= moment.utc(_minDate, 'YYYY-MM-DD') ? moment.utc(_startDate, 'YYYY-MM-DD') : moment.utc(_minDate, 'YYYY-MM-DD'),
      maxDateEnd: moment.utc(_maxDate, 'YYYY-MM-DD'),
      focused: null,
      error: null
    };
    moment.locale('fr');
    return _this;
  }

  /**
     * Component did update.
     *
     * @param {*} prevProps
     * @memberof DateRange
     */
  var _proto = DateRange.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props3 = this.props,
      startDate = _this$props3.startDate,
      endDate = _this$props3.endDate;
    var prevStartDate = prevProps.startDate,
      prevEndDate = prevProps.endDate;
    if (!_.isEqual(startDate, prevStartDate)) {
      this.updateStartDate(startDate);
    }
    if (!_.isEqual(endDate, prevEndDate)) {
      this.updateEndDate(endDate);
    }
  };
  /**
     * Render the component.
     *
     * @returns
     * @memberof DateRange
     */
  _proto.render = function render() {
    var label = this.props.label;
    var error = this.state.error;
    if (!_.isNil(label)) {
      return /*#__PURE__*/_jsx(Tooltip, {
        type: !_.isNil(error) ? 'error' : '',
        position: "bottom left",
        message: error,
        open: !_.isNil(error),
        trigger: /*#__PURE__*/_jsxs(Form.Field, {
          children: [/*#__PURE__*/_jsx("label", {
            children: label
          }), " ", this.renderPicker()]
        })
      });
    }
    return this.renderPicker();
  };
  return DateRange;
}(React.Component);
/**
 * Prop types.
 */
DateRange.handledProps = ["calendar", "clearable", "endDate", "isOutsideRange", "label", "maxDate", "minDate", "onClear", "onDatesChange", "onFocusChange", "startDate"];
DateRange.propTypes = {
  /** Function called when dates change. */
  onDatesChange: PropTypes.func,
  /** Function called when focus change. */
  onFocusChange: PropTypes.func,
  /** Function called when component is cleared */
  onClear: PropTypes.func,
  /** Value of start date input. */
  startDate: PropTypes.string,
  /** Value of end date input. */
  endDate: PropTypes.string,
  /** Label of the input. */
  label: PropTypes.string,
  /** Whether or not the field shows the date picker icon and on focus. */
  calendar: PropTypes.bool,
  /** Whether or not the field is clearable.  */
  clearable: PropTypes.bool,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  isOutsideRange: PropTypes.func
};
export default DateRange;